import { ModalRoot } from '@cian/ui-kit';
import { ILegalInfoFieldSchema } from 'node/repositories/offer-card/entities/legal_info_block/LegalInfoFieldSchema';
import * as React from 'react';
import { LegalInfoButton } from 'shared/components/LegalInfoButton';
import { LegalInfoModal } from 'shared/components/LegalInfoModal';

import { useLegalInfoModal } from './useLegalInfoModal';

export const LegalInfoContainer: React.FC = () => {
  const { isOpen, handleButtonClick, handleLinkClick, closeModal, legalInfo, isVisible } = useLegalInfoModal();

  if (!isVisible) {
    return null;
  }

  return (
    <ModalRoot open={isOpen} onOpenChange={closeModal}>
      <LegalInfoButton title={legalInfo?.title} onClick={handleButtonClick} />
      <LegalInfoModal
        title={legalInfo?.title}
        onLinkClick={handleLinkClick}
        fields={legalInfo?.fields as ILegalInfoFieldSchema[]}
      />
    </ModalRoot>
  );
};
